import customFontsApi from '@/api/customFonts'

const TOKEN_PATTERN = /^ahacf-[0-9a-f]{32}$/
const SAFE_URL_PATTERN = /^https:\/\/[^\s"'()<>\\]+$/
const FORMAT_HINTS = {
  ttf: 'truetype',
  otf: 'opentype',
  woff: 'woff',
  woff2: 'woff2',
}
export const DEFAULT_FONT_FAMILY = 'Plus Jakarta Sans'
const FALLBACK_STACK = `"${DEFAULT_FONT_FAMILY}", Cairo, sans-serif`
const STYLE_ATTRIBUTE = 'data-aha-custom-font'

const pendingByToken = new Map()

export const isCustomFontToken = (font) => typeof font === 'string' && TOKEN_PATTERN.test(font)

export const customFontStack = (token) => `"${token}", ${FALLBACK_STACK}`

const isInjected = (token) => Boolean(document.head.querySelector(`style[${STYLE_ATTRIBUTE}="${token}"]`))

export const injectCustomFont = ({ id, url, format }) => {
  if (!isCustomFontToken(id) || !FORMAT_HINTS[format] || !SAFE_URL_PATTERN.test(url || '')) return false
  if (isInjected(id)) return true
  const styleEl = document.createElement('style')
  styleEl.setAttribute(STYLE_ATTRIBUTE, id)
  styleEl.textContent = `@font-face { font-family: "${id}"; src: url("${url}") format("${FORMAT_HINTS[format]}"); font-display: swap; }`
  document.head.appendChild(styleEl)
  return true
}

export const applyCustomFont = (token) => {
  if (!isCustomFontToken(token)) return Promise.resolve(false)
  if (isInjected(token)) return Promise.resolve(true)
  if (pendingByToken.has(token)) return pendingByToken.get(token)
  const pending = customFontsApi.resolve(token)
    .then((font) => Boolean(font) && injectCustomFont({ ...font, id: token }))
    .catch(() => false)
    .finally(() => pendingByToken.delete(token))
  pendingByToken.set(token, pending)
  return pending
}
